import { isRequestedProductV1, isRequestedQuantityV1 } from './purchaseMotionTypeGuards';
export const toPurchaseRequestV2 = request => {
  const result = {
    currencyCode: request.currencyCode,
    commitmentTerm: request.commitmentTerm,
    paymentTerm: request.paymentTerm,
    products: (request.products || []).map(product => {
      if (isRequestedProductV1(product)) {
        var _product$totalQuantit;
        const skuQuantity = (_product$totalQuantit = product.totalQuantity) !== null && _product$totalQuantit !== void 0 ? _product$totalQuantit : product.quantity;
        const incrementalQuantity = product.incrementalQuantity;

        // prefer incrementalQuantity over skuQuantity
        if (incrementalQuantity) {
          return {
            productApiName: product.productApiName,
            incrementalQuantity
          };
        }
        return {
          productApiName: product.productApiName,
          skuQuantity
        };
      }
      return product;
    })
  };
  if (request.quantityPacks) {
    result.quantityPacks = request.quantityPacks.map(pack => {
      if (isRequestedQuantityV1(pack)) {
        const skuQuantity = pack.totalQuantity;
        const incrementalQuantity = pack.incrementalQuantity;
        if (incrementalQuantity) {
          return {
            quantityName: pack.quantityName,
            incrementalQuantity,
            parentProductApiName: pack.parentProductApiName
          };
        }
        return {
          quantityName: pack.quantityName,
          skuQuantity,
          parentProductApiName: pack.parentProductApiName
        };
      }
      return pack;
    });
  }
  return result;
};